"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BussproofsMethods_js_1 = require("./BussproofsMethods.js");

var ParseMethods_js_1 = require("../ParseMethods.js");

var SymbolMap_js_1 = require("../SymbolMap.js");

new SymbolMap_js_1.CommandMap('Bussproofs-macros', {
  AxiomC: 'Axiom',
  UnaryInfC: ['Inference', 1],
  BinaryInfC: ['Inference', 2],
  TrinaryInfC: ['Inference', 3],
  QuaternaryInfC: ['Inference', 4],
  QuinaryInfC: ['Inference', 5],
  RightLabel: ['Label', 'right'],
  LeftLabel: ['Label', 'left'],
  AXC: 'Axiom',
  UIC: ['Inference', 1],
  BIC: ['Inference', 2],
  TIC: ['Inference', 3],
  RL: ['Label', 'right'],
  LL: ['Label', 'left'],
  noLine: ['SetLine', 'none', false],
  singleLine: ['SetLine', 'solid', false],
  solidLine: ['SetLine', 'solid', false],
  dashedLine: ['SetLine', 'dashed', false],
  alwaysNoLine: ['SetLine', 'none', true],
  alwaysSingleLine: ['SetLine', 'solid', true],
  alwaysSolidLine: ['SetLine', 'solid', true],
  alwaysDashedLine: ['SetLine', 'dashed', true],
  rootAtTop: ['RootAtTop', true],
  alwaysRootAtTop: ['RootAtTop', true],
  rootAtBottom: ['RootAtTop', false],
  alwaysRootAtBottom: ['RootAtTop', false],
  fCenter: 'FCenter',
  Axiom: 'AxiomF',
  UnaryInf: ['InferenceF', 1],
  BinaryInf: ['InferenceF', 2],
  TrinaryInf: ['InferenceF', 3],
  QuaternaryInf: ['InferenceF', 4],
  QuinaryInf: ['InferenceF', 5]
}, BussproofsMethods_js_1.default);
new SymbolMap_js_1.EnvironmentMap('Bussproofs-environments', ParseMethods_js_1.default.environment, {
  prooftree: ['Prooftree', null, false]
}, BussproofsMethods_js_1.default);